import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const createProfileVisiteur = async (token: string, profileData: object) => {
  try {
    const response = await Axios.post(`${SERVER_BASE_URL}api/profileVisiteur/`, profileData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
